<navigation forceTitle="IoTnet Gateways"></navigation>

<div class="map" [style.top.px]="topOffset()">
  <iotnet-map [gateways]="gateways.value()" [(selectedGateway)]="selectedGateway" />

  @if (selectedGateway(); as gateway) {
    <iotnet-gateway-detail
      class="gateway-detail-overlay"
      [gateway]="gateway"
      [customerId]="customerId()"
      (closed)="selectedGateway.set(null)"
    />
  }
</div>
